import React from 'react';
// import '@style/components/hexagonGrid.scss';
import '../styles/components/hexagonGrid.scss';
import HexagonTile from '@components/hexagonTile';

const HexagonGrid = ({ data, selectedId, onClickHandler }) => {
  const sorted = data.sort((a, b) => a.displayOrder - b.displayOrder);

  return (
    <ul className="hex-grid__list">
      {sorted.map((e) => (
        <HexagonTile
          id={e.id}
          name={e.name}
          selectedId={selectedId}
          onClickHandler={onClickHandler}
        />
      ))}
    </ul>
  );
};

export default HexagonGrid;
